// Amount of results per page
export const PAGE_RESULT_CARD_AMOUNT = 12;

// Amount of results per page in the offer event overview list
export const OFFER_EVENT_LIST_AMOUNT = 50;
